import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
  AssetLocation, AssetLocationRequest, AssetTransfer, AssetTransferRegisterFilter, AssetTransferRequest,
  CustodianOption, MyAsset,
} from '../interfaces/fixedAsset/fixedAssetTransfer.interface';

// F10: every route is institution-addressed; the server scopes each lookup to that institution.
const E = ENDPOINTS.FIXED_ASSET_TRANSFER;
const institution = () => AuthService.getSelectedInstitution()!;

export const FixedAssetTransferService = {
  locations: async (): Promise<AssetLocation[]> => (await axios.get(E.LOCATIONS(institution()))).data,
  createLocation: async (dto: AssetLocationRequest): Promise<AssetLocation> =>
    (await axios.post(E.LOCATIONS(institution()), dto)).data,
  updateLocation: async (id: string, dto: AssetLocationRequest): Promise<AssetLocation> =>
    (await axios.put(E.LOCATION(institution(), id), dto)).data,
  setLocationActive: async (id: string, active: boolean): Promise<AssetLocation> =>
    (await axios.post(active ? E.LOCATION_ACTIVATE(institution(), id) : E.LOCATION_DEACTIVATE(institution(), id))).data,

  history: async (assetId: string): Promise<AssetTransfer[]> =>
    (await axios.get(E.ASSET_TRANSFERS(institution(), assetId))).data,
  transfer: async (assetId: string, dto: AssetTransferRequest): Promise<AssetTransfer> =>
    (await axios.post(E.ASSET_TRANSFERS(institution(), assetId), dto)).data,
  reverse: async (transferId: string): Promise<AssetTransfer> =>
    (await axios.post(E.REVERSE(institution(), transferId))).data,
  register: async (f: AssetTransferRegisterFilter): Promise<{ content: AssetTransfer[]; totalElements: number }> =>
    (await axios.get(E.REGISTER(institution()), { params: f })).data,

  myAssets: async (): Promise<MyAsset[]> => (await axios.get(E.MY_ASSETS(institution()))).data,
  custodians: async (search?: string): Promise<CustodianOption[]> =>
    (await axios.get(E.CUSTODIANS(institution()), { params: search ? { search } : undefined })).data,
};
